import React, {Component} from "react";
import AppSidebar from "../../components/AppSidebar";
import PageHeader from "../../components/PageHeader";
import ActionButton from "../../components/ActionButton";
import PanelGroupController from "../../components/PanelGroupController";
import WaterPalletsList from "./views/WaterPalletsList";
import WaterContainersList from "./views/WaterContainersList";
import WaterPalletPropertiesPanel from "./panels/WaterPalletPropertiesPanel";
import WaterContainerPropertiesPanel from "./panels/WaterContainerPropertiesPanel";
import SkuFilterPanel from "./panels/SkuFilterPanel";
import {List} from "immutable";

class WaterPalletsPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.handleSetContainerSelection = this.handleSetContainerSelection.bind(this);
    this.handleViewPalletId = this.handleViewPalletId.bind(this);
    this.handleAddWaterContainerToPallet = this.handleAddWaterContainerToPallet.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.state = {
      // in one "pallet" mode, the pallet id is in the router params:
      palletId: this.props.params.palletId,
      hasPalletSelection: false,
      containerId: "",
      hasContainerSelection: false,
      skuFilter: ""
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.route.page === "pallet" && this.props.route.page === "pallets") {
      this.setState({containerId: "", hasContainerSelection: false});
    }
  }

  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Water Pallets";
    // page: "pallets" vs "pallet"!
    if (page === "pallet") {
      title = `${title} / ${this.state.palletId}`;
    }

    return (
      <div className="WaterPalletsPage SecurePage">
        <AppSidebar />
        <PageHeader title={title} backButton={page === "pallet"} onBack={this.handleBack}/>
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header" />
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton 
              label="Register Pallet"
              show={page === "pallets"}
              onClick={this.handleRegisterWaterPallet.bind(this)} />
            <ActionButton 
              label="Record Water Test Result"
              active={this.state.hasPalletSelection}
              show={page === "pallets"}
              onClick={this.handleRecordWaterTestResult.bind(this)} />
            <ActionButton 
              label="Lookup Serial Number" 
              active={false}
              show={page === "pallets"}
              onClick={this.handleLookupSerialNumber.bind(this)} />
            <ActionButton 
              label="Decommission Bottle" 
              active={page === "pallet" && this.state.hasContainerSelection}
              show={page === "pallet"}
              onClick={this.handleRejectContainer.bind(this)} />
            <ActionButton 
              label="Add Bottle to Pallet" 
              active={page === "pallet"}
              show={page === "pallet"}
              onClick={this.handleAddWaterContainerToPallet.bind(this)} />
            <ActionButton 
              label="Release Pallet to Stock" 
              active={false}
              show={page === "pallets"}
              onClick={this.handleReleaseWaterPalletToStock.bind(this)} />
          </PanelGroupController>
        </div>
      </div>
    )
  }

  renderView(page) {
    switch(page) {
      case "pallets":
        return (
          <WaterPalletsList 
            key="WaterPalletsList"
            selectedPalletId={this.state.palletId} 
            onSelectionChange={this.handleSetSelection}
            onPalletIdClick={this.handleViewPalletId}
            hasSelection={this.state.hasPalletSelection}
            skuFilter={this.state.skuFilter}
            />
        )
      case "pallet":
        return (
          <WaterContainersList
            key="WaterContainersList"
            palletId={this.props.params.palletId}
            selectedId={this.state.containerId}
            hasSelection={this.state.hasContainerSelection}
            onSelectionChange={this.handleSetContainerSelection}
            />
        )
      default: 
        return <p>No view found</p>
    }
  }

  renderPanels(page) {
    switch(page) {
      case "pallets":
        return this.buildPanels(List(["skuFilter", WaterPalletPropertiesPanel]));
      case "pallet":
        return this.buildPanels(List([WaterContainerPropertiesPanel, WaterPalletPropertiesPanel]));
      default:
        return null;
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case WaterPalletPropertiesPanel:
        return <WaterPalletPropertiesPanel
                key="WaterPalletPropertiesPanel"
                expanded={this.props.route.page === "pallets"}
                selectedPalletId={this.state.palletId}
                hasSelection={this.state.hasPalletSelection}
                />
      case WaterContainerPropertiesPanel:
        return <WaterContainerPropertiesPanel
                key="WaterContainerPropertiesPanel"
                expanded={true}
                selectedId={this.state.containerId}
                hasSelection={this.state.hasContainerSelection}
                />     
      case "skuFilter":
        return <SkuFilterPanel
          key="SkuFilterPanel"
          title="Product Filter"
          onClick={this.handleSetSkuFilter.bind(this)}
          filter={this.state.skuFilter}
          />                              
      default:
        return null;      
    }
  }

  handleSetSelection(id) {
    this.setState({palletId: id, hasPalletSelection: true});
  }

  handleSetContainerSelection(id, sku) {
    this.setState({containerId: id, hasContainerSelection: true});
  }

  handleRecordWaterTestResult() {
    this.props.requestRecordWaterTestResultInput(this.state.palletId);
  }

  handleRegisterWaterPallet() {
    this.props.requestRegisterWaterPallet();
  }

  handleLookupSerialNumber() {
    // this.props.requestCreateProductBundle();
  }

  handleSetSkuFilter(sku) {
    this.setState({
      skuFilter: sku
    });
  }     

  handleViewPalletId(palletId) {
    this.handleSetSelection(palletId);
    this.props.router.push(`/inventory/water-pallets/${palletId}`);    
  }

  handleRejectContainer() {
    this.props.requestRejectWaterContainer(this.state.palletId, this.state.containerId);
  }

  handleAddWaterContainerToPallet() {
    this.props.requestAddWaterContainerToPallet(this.state.palletId);
  }

  handleReleaseWaterPalletToStock() {
    // this.props.requestAddWaterContainerToPallet(this.state.palletId);
  }

  handleBack() {
    this.props.router.push(`/inventory/water-pallets`);
  }

}

export default WaterPalletsPage;